<template>
  <div class="video-play">
    <div class="danmu-wrapper" @click="clickTest">
      <div class="danmu-tarck-1">
        <div class="danmu-content" v-for="(item, index) in danmuList1" :key="index">{{ item }}</div>
      </div>
      <div class="danmu-tarck-2">
        <div class="danmu-content" v-for="(item, index) in danmuList2" :key="index">{{ item }}</div>
      </div>
      <div class="columns-info">
        <div class="columns-name">
          <span class="span-left">「</span> {{ playInfo.columnsName
          }}<span class="span-right">」</span>
        </div>
        <div class="columns-title">{{ playInfo.name }}</div>
      </div>
    </div>
    <div class="video-wrapper">
      <video
        ref="videoRef"
        class="video-class"
        src="https://live.hcfm.gztv.com/filedata/hcfm/data/135/kuai1.mp4"
        poster="https://live.hcfm.gztv.com/filedata/hcfm/data/135/kuai.jpg"
        x5-video-player-type="h5-page"
        playsinline="true"
        :width="videoWidth"
        :height="videoHeight"
      />
    </div>
  </div>
</template>

<script>
import { useRoute } from "vue-router";
import { defineComponent, onMounted, ref } from "vue";
import { queryHistoryProgramByName } from "@/http/api.js";

export default defineComponent({
  name: "ColumnsVideoPlay",
  setup() {
    const route = useRoute();
    const playInfo = ref({});
    const videoRef = ref(null);
    const videoWidth = ref(0);
    const videoHeight = ref(0);
    let danmuList = [
      "第1个弹幕",
      "第2个弹幕",
      "第3个弹幕",
      "第4个弹幕",
      "第5个弹幕",
      "第6个弹幕",
      "第7个弹幕",
      "第8个弹幕",
      "第9个弹幕",
      "第10个弹幕",
      "第11个弹幕",
      "第12个弹幕"
    ];
    const danmuList1 = ref([]);
    const danmuList2 = ref([]);
    let timer = null;

    const getProgramInfo = async id => {
      const result = await queryHistoryProgramByName({
        flag: "play",
        id: route.query.id,
        page: 1,
        rows: 10,
        order: 1
      });
      console.log(result.data);
      playInfo.value = result.data.pageList[0];
      // playInfo.value.bgColour = playInfo.value.bgColour.replace(/\s/g, "");
      // playInfo.value.bgColourOpacity = `rgba(${playInfo.value.bgColour
      //   .substring(4)
      //   .replace(/\)/, "")},0.6)`;
      // console.log(playInfo.value);
      // audioRef.value.src = playInfo.value.audioViderUrl;
      // if (
      //   playInfo.value.introduction != null &&
      //   playInfo.value.introduction != "" &&
      //   playInfo.value.introduction.length > 1
      // ) {
      //   showIntroBtn.value = true;
      // }
    };

    const clickTest = () => {
      videoRef.value.play();
      videoRef.value.poster = "";
    };

    onMounted(() => {
      danmuList1.value.push(danmuList.shift());
      danmuList2.value.push(danmuList.shift());
      videoWidth.value = window.innerWidth;
      videoHeight.value = `${window.innerHeight / 3}px`;
      getProgramInfo();

      setInterval(() => {
        if (danmuList.length === 0 && !timer) {
          timer = setTimeout(() => {
            danmuList = [...danmuList1.value, ...danmuList2.value];
            danmuList1.value = [];
            danmuList2.value = [];
            clearTimeout(timer);
            timer = null;
          }, 3500);
        } else if (danmuList.length > 0) {
          danmuList1.value.push(danmuList.shift());
          danmuList2.value.push(danmuList.shift());
        }
      }, 1000);
    });

    return {
      danmuList,
      danmuList1,
      danmuList2,
      playInfo,
      videoRef,
      clickTest,
      videoWidth,
      videoHeight
    };
  }
});
</script>

<style lang="scss" scoped>
.video-play {
  position: fixed;
  z-index: 9991;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 1);
  max-width: 500px;
  margin: 0 auto;

  .danmu-wrapper {
    position: absolute;
    top: 0;
    width: 100%;
    height: 200px;

    .danmu-tarck-1 {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      margin-top: 30px;

      .danmu-content {
        position: absolute;
        display: inline-block;
        flex-shrink: 0;
        color: #fffefe; // 文字颜色
        // text-shadow: 2px 2px 3px #fffefe; // 文字阴影
        transform: translateX(100vw); // 文字起始位置
        animation: scrollTo linear 4s 0.5s; // 动画
      }

      @keyframes scrollTo {
        to {
          transform: translateX(-100px);
        }
      }
    }

    .danmu-tarck-2 {
      display: flex;
      align-items: center;
      width: 100%;
      height: 40px;
      margin-top: 15px;

      .danmu-content {
        position: absolute;
        display: inline-block;
        flex-shrink: 0;
        color: #fffefe; // 文字颜色
        // text-shadow: 2px 2px 3px #fffefe; // 文字阴影
        transform: translateX(100vw); // 文字起始位置
        animation: scrollTo linear 4s; // 动画
      }

      @keyframes scrollTo {
        to {
          transform: translateX(-100px);
        }
      }
    }

    .columns-info {
      position: absolute;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
      letter-spacing: 2px;
      text-indent: 2px;

      .columns-name {
        display: flex;
        align-items: center;
        color: burlywood;
        font-size: 20px;
        font-weight: bold;

        & > span {
          font-size: 16px;
          font-weight: 400;
        }

        .span-left {
          margin-right: 12px;
        }

        .span-right {
          margin-left: 12px;
        }
      }

      .columns-title {
        color: burlywood;
        font-size: 20px;
        font-weight: bold;
        margin-top: 20px;
      }
    }
  }

  .video-wrapper {
    position: absolute;
    width: 100%;
    height: 280px;
    top: 200px;

    .video-class {
      width: 100% !important;
      height: 280px;
    }
  }
}
</style>
